import { formatRawAsLocal } from "core-integration/src/utils/datetime";
import HorizontalDivider from "plos/src/components/HorizontalDivider";
import ButtonLink from "plos/src/components/links/ButtonLink";
import { edgeToEdge } from "plos/src/styles";
import { visuallyHidden } from "plos/src/styles/utils.css";
import { useTranslation } from "react-i18next";
import lastFanStandingImage from "../../../../img/last-fan-standing-promo.png";
import { ControlArrowRight } from "../../../icons/Arrows";

// Saturday 10 October 12:30 BST
const lastFanStandingDeadline = "2026-10-10T11:30:00Z";

const LastFanStandingContent = () => {
  const { t } = useTranslation("pickTeam");

  return (
    <>
      <h3>{t("teamSaved", "Team Saved")}</h3>
      <div className={edgeToEdge}>
        <img
          src={lastFanStandingImage}
          alt={t("lastFanStanding.imageAlt", "Last Fan Standing")}
        />
        <span className={visuallyHidden}>
          {t(
            "lastFanStanding.instructions",
            "Pick one team to win each week. If they win, you survive. Lose or draw and you're eliminated. You can only pick each team once.",
          )}
        </span>
      </div>
      <p>
        {t(
          "lastFanStanding.copy",
          "Last Fan Standing is back! Play October Entry for the chance to win a trip to a Premier League game. Enter by {{deadline}}.",
          { deadline: formatRawAsLocal(lastFanStandingDeadline) },
        )}
      </p>
      <HorizontalDivider />
      <ButtonLink
        to={`${
          import.meta.env.VITE_HF_BASE
        }/en/news/4729066/last-fan-standing-october-entry-win-a-trip-to-a-premier-league-match/`}
        size="small"
      >
        {t("lastFanStanding.link", "Play Last Fan Standing")}
        <ControlArrowRight />
      </ButtonLink>
    </>
  );
};

export default LastFanStandingContent;
